import { NavigatorDetail } from '@/media/changeDomain';
import {
  Alert, Button, TextField,
} from 'gatorcomponents';
import React from 'react';
import * as Styles from './InputDomain.styles';
import { useResize } from '@/hooks/useResize';

const InputDomain = ({
  title,
  description,
  backCta,
  continueCta,
  alertDescription,
  newDomain,
  onChangeDomain,
  onBack,
  domainIsOk,
  onContinue,
  loadingChange,
  originalDomain,
  mySiteLabel,
}) => {
  const windowRect = useResize();
  const { width } = windowRect;
  const mobile = width < 960;

  const handleBack = () => {
    onBack && onBack();
  };

  const handleContinue = (e) => {
    e.preventDefault();
    if (!newDomain.error) {
      onContinue && onContinue();
    }
  };

  const handleChangeDomain = (e) => {
    onChangeDomain && onChangeDomain(e);
  };

  return (
    <Styles.InputDomainWrapper data-testid="input-domain-wrapper">
      <Styles.FirstRow>
        <Styles.Title>{title}</Styles.Title>
        <Styles.Description>{description}</Styles.Description>
      </Styles.FirstRow>

      {!mobile && (
        <NavigatorDetail />
      )}

      <Styles.TextFieldWrapper autoComplete="off" onSubmit={handleContinue}>
        <TextField
          label={mySiteLabel}
          onChange={handleChangeDomain}
          maxLength={63}
          value={newDomain.value}
          helpText={newDomain.error}
          status={newDomain.error ? 'error' : 'normal'}
          testId="inputDomain"
        />
      </Styles.TextFieldWrapper>

      <Styles.AlertWrapper>
        <Alert
          withoutBackground
          description={alertDescription(originalDomain)}
          customIcon="IconCardRefresh"
          customIconColor="lowDark"
          centerIcon
        />
      </Styles.AlertWrapper>

      <Styles.ActionsWrapper>
        <Button
          label={backCta}
          variant="tertiary"
          onClick={handleBack}
          size="large"
          disabled={loadingChange}
          testId="backButton"
        />
        <Button
          label={continueCta}
          onClick={handleContinue}
          size="large"
          disabled={!domainIsOk || loadingChange || newDomain.error}
          loading={loadingChange}
          testId="continueButton"
        />
      </Styles.ActionsWrapper>

    </Styles.InputDomainWrapper>
  );
};

export default InputDomain;
